export const EXSBDOCUMENTTYPE_CREATE_RESET = 'EXSBDOCUMENTTYPE_CREATE_RESET'
export const EXSBDOCUMENTTYPE_CREATE_SET_CREATED = 'EXSBDOCUMENTTYPE_CREATE_SET_CREATED'
export const EXSBDOCUMENTTYPE_CREATE_SET_ERROR = 'EXSBDOCUMENTTYPE_CREATE_SET_ERROR'
export const EXSBDOCUMENTTYPE_CREATE_SET_VIOLATIONS = 'EXSBDOCUMENTTYPE_CREATE_SET_VIOLATIONS'
export const EXSBDOCUMENTTYPE_CREATE_TOGGLE_LOADING = 'EXSBDOCUMENTTYPE_CREATE_TOGGLE_LOADING'
